const stringify = (obj, sep = '&', eql = '=', wrap = '') =>
  Object.keys(obj)
    .map(key => {
      if (typeof obj[key] === 'object') {
        return stringify(obj[key], sep, eql, key);
      }
      const safeKey = wrap ? `${encodeURIComponent(wrap)}[${encodeURIComponent(key)}]` : encodeURIComponent(key);
      return `${safeKey}${eql}${encodeURIComponent(obj[key])}`;
    })
    .join(sep);

export default stringify;
